import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import gsap from "gsap";
// Create a SymbolPool class to manage the pool of symbols
class ScatterParticlePool {
  private pool: ScatterParticle[] = [];

  constructor(initialPoolSize: number = 10) {
    for (let i = 0; i < initialPoolSize; i++) {
      this.pool.push(new ScatterParticle());
    }
  }

  public acquire(): ScatterParticle {
    if (this.pool.length > 0) {
      const scatterParticle = this.pool.pop();
      if (scatterParticle) {
        scatterParticle.visible = true;
        scatterParticle.position.set(0, 0);
        scatterParticle.reset();
      }
      return scatterParticle!;
    } else {
      return new ScatterParticle();
    }
  }

  public release(scatterParticle: ScatterParticle) {
    scatterParticle.visible = false;
    this.pool.push(scatterParticle);
  }
}
export class ScatterParticle extends PIXI.Container {
  private static _pool: ScatterParticlePool;

  public static get pool(): ScatterParticlePool {
    if (!ScatterParticle._pool) {
      throw new Error(
        "ScatterParticle pool is not initialized. Call Symbol.createPool() first.",
      );
    }
    return ScatterParticle._pool;
  }
  public static createPool(initialPoolSize: number = 10) {
    ScatterParticle._pool = new ScatterParticlePool(initialPoolSize);
  }

  private skeleton: Spine;

  constructor() {
    super();
    this.skeleton = Spine.from({
      skeleton: "projectileJson",
      atlas: "projectileAtlas",
    });
    this.skeleton.scale.set(0.1);
    this.addChild(this.skeleton);
    this.skeleton.state.setAnimation(0, "idle", true);

    this.skeleton.state.addListener({
      event: function (entry, event) {},
      complete: (entry) => {
        if (entry.animation && entry.animation.name === "explosion") {
          this.visible = false;
          ScatterParticle.pool.release(this);
        }
      },
      start: () => {},
      end: function (entry) {},
      dispose: function (entry) {},
    });
  }

  reset() {
    this.skeleton.state.setAnimation(0, "idle", true);
    this.rotation = 0;
  }

  async collect(x: number, y: number) {
    return new Promise<void>((resolve) => {
      // Calculate rotation
      const deltaX = x - this.x;
      const deltaY = y - this.y;
      const angle = Math.atan2(deltaY, deltaX); // Rotation in radians
      this.rotation = angle - (90 * Math.PI) / 180;

      gsap.to(this, {
        x,
        y,
        duration: 0.2,
        scaleX: 1,
        scaleY: 1,
        rotation: angle - (90 * Math.PI) / 180,
        onComplete: () => {
          this.skeleton.state.setAnimation(0, "explosion", false);
          resolve();
        },
        ease: "power1.inOut",
      });
    });
  }
}
